import { useMemo } from "react";

import classNames from "classnames";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  setBlur,
  setHeaderMenuOpen,
  setShowLoginDialog,
} from "../../redux/reducers/uiReducer";

import LangSwitch from "../lang-switch";

import { logDebug } from "../../utils/logger.js";
import { equalsIgnoringCase } from "../../utils/validators.js";

function HeaderMenu() {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { ui } = useSelector((state) => state);

  const isActiveAboutLink = useMemo(() => {
    return equalsIgnoringCase(ui.navigation_index, "about");
  }, [ui.navigation_index]);

  const isActivePlansLink = useMemo(() => {
    return equalsIgnoringCase(ui.navigation_index, "plans");
  }, [ui.navigation_index]);

  const goToLandingAboutHandler = (evt) => {
    logDebug("HeaderMenu", "goToLandingAboutHandler", { evt: evt });
    dispatch(setHeaderMenuOpen(false));
    window.location.replace(process.env.REACT_APP_PUBLIC_URL);
  };

  const goToLandingPlansHandler = (evt) => {
    logDebug("HeaderMenu", "goToLandingPlansHandler", { evt: evt });
    window.location.replace(process.env.REACT_APP_PUBLIC_URL);
    dispatch(setHeaderMenuOpen(false));
  };

  const showLoginDialog = (evt) => {
    logDebug("HeaderMenu", "showLoginDialog", { evt: evt });
    dispatch(setHeaderMenuOpen(!ui.header_menu_open));
    dispatch(setShowLoginDialog(!ui.show_login_dialog));
    dispatch(setBlur(!ui.is_blur));
  };

  return (
    <nav
      className={classNames("header-menu", { open: ui.header_menu_open })}
      style={{ maxHeight: `${ui.header_menu_open ? 200 : 0}px` }}
    >
      <ul className="header-menu__items">
        <li
          id="header-about-link"
          className={classNames("header-menu__item", {
            active: isActiveAboutLink,
          })}
          onClick={(evt) => goToLandingAboutHandler(evt)}
        >
          <span className="icon-logo"></span>
          <span className="small-title">{t("header_menu.about_us")}</span>
          <span className="icon-nav-arrow-right"></span>
        </li>
        <li
          id="header-plans-link"
          className={classNames("header-menu__item", {
            active: isActivePlansLink,
          })}
          onClick={(evt) => goToLandingPlansHandler(evt)}
        >
          <span className="icon-stats-square-up-outline"></span>
          <span className="small-title">{t("header_menu.plans")}</span>
          <span className="icon-nav-arrow-right"></span>
        </li>
        <li
          id="header-login-link"
          className="header-menu__item"
          onClick={() => showLoginDialog()}
        >
          <span className="icon-user-outline"></span>
          <span className="small-title">{t("header_menu.account")}</span>
          <span className="icon-nav-arrow-right"></span>
        </li>
        <li
          className="header-menu__item"
          style={{ justifyContent: "flex-end" }}
        >
          <LangSwitch />
        </li>
      </ul>
    </nav>
  );
}

export default HeaderMenu;
